import { Post } from '@wellesley/openapi'

const findFeed = (
  feedId: string,
  feed?: Post | null,
  skipOriginalPost = false,
  condition = (feed: Post) => !!feed,
) => {
  let result
  if (feed?.id === feedId && condition(feed)) return feed
  else if (!skipOriginalPost && feed?.originalPost?.id === feedId) return feed
  else if (!skipOriginalPost && feed?.parent?.id === feedId) return feed

  feed?.replies?.some((reply) => {
    result = findFeed(feedId, reply, skipOriginalPost, condition)
    return !!result
  })

  return result
}

export default findFeed
